import { render } from "./OpenIcon.vue?vue&type=template&id=1ee2108c"
const script = {}

import exportComponent from "/app/tmp/origina/V3/v2026.15.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__